import { Sangha } from "@app/shared/types";
import { DateTime } from "luxon";

export enum TimeOfDayOptions {
    any = "any time of the day",
    morning = "mornings",
    afternoon = "afternoons",
    evening = "evenings",
}

const timeWindowMap: Record<TimeOfDayOptions, { start: number; end: number }> = {
    [TimeOfDayOptions.any]: { start: 0, end: 24 },
    [TimeOfDayOptions.morning]: { start: 6, end: 12 },
    [TimeOfDayOptions.afternoon]: { start: 12, end: 17 },
    [TimeOfDayOptions.evening]: { start: 17, end: 21 },
};

const getTimeFromGroup = (
    group: Sangha,
    timezone: string,
    firstSessionDate?: boolean,
): DateTime => {
    if (firstSessionDate) {
        return group.schedule.firstSessionDate
            ? DateTime.fromISO(group.schedule.firstSessionDate, {
                  zone: timezone,
              })
            : DateTime.fromISO("");
    }

    return group.schedule.nextSession?.time
        ? DateTime.fromISO(group.schedule.nextSession?.time, {
              zone: timezone,
          })
        : DateTime.fromISO("");
};

export const groupMatchesTimeOfDay = (
    group: Sangha,
    selectedTimeOfDay: TimeOfDayOptions,
    timezone: string,
    useFirstSessionDate?: boolean,
) => {
    if (selectedTimeOfDay === TimeOfDayOptions.any) {
        return true;
    }
    const timeWindow = timeWindowMap[selectedTimeOfDay];

    return (
        getTimeFromGroup(group, timezone, useFirstSessionDate).hour >= timeWindow.start &&
        getTimeFromGroup(group, timezone, useFirstSessionDate).hour < timeWindow.end
    );
};
